async function getCart() {
  return fetch('/cart.js').then(function (r) { return r.json(); });
}

async function bundleUpdate(updates) {
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates })
  });
}

// Change quantity of entire bundle together
async function changeBundleQuantity(parentKey, delta) {
  const cart = await getCart();
  const parent = cart.items.find(function (i) { return i.key === parentKey; });
  if (!parent) return;

  const newQty = parent.quantity + delta;
  if (newQty < 1) return;

  const bid = parent.properties && parent.properties._bundle_id;
  if (!bid) return;

  const updates = {};
  cart.items.forEach(function (item) {
    if (item.properties && item.properties._bundle_id === bid) {
      updates[item.key] = newQty;
    }
  });

  await bundleUpdate(updates);
  location.reload();
}

// Remove entire bundle
async function removeBundle(parentKey) {
  const cart = await getCart();
  const parent = cart.items.find(function (i) { return i.key === parentKey; });
  if (!parent) return;

  const bid = parent.properties && parent.properties._bundle_id;
  if (!bid) return;

  const updates = {};
  cart.items.forEach(function (item) {
    if (item.properties && item.properties._bundle_id === bid) {
      updates[item.key] = 0;
    }
  });

  await bundleUpdate(updates);
  location.reload();
}

document.addEventListener('click', function (e) {

  // Remove bundle
  const removeBtn = e.target.closest('.bundle-remove');
  if (removeBtn) {
    e.preventDefault();
    e.stopImmediatePropagation();
    removeBundle(removeBtn.dataset.key);
    return;
  }

  // Increase bundle quantity
  const plusBtn = e.target.closest('.bundle-qty-plus');
  if (plusBtn) {
    e.preventDefault();
    e.stopImmediatePropagation();
    changeBundleQuantity(plusBtn.dataset.key, 1);
    return;
  }

  // Decrease bundle quantity
  const minusBtn = e.target.closest('.bundle-qty-minus');
  if (minusBtn) {
    e.preventDefault();
    e.stopImmediatePropagation();
    changeBundleQuantity(minusBtn.dataset.key, -1);
    return;
  }

});